import Container from './Home-container';

const ViewComponent = ({}) => (
  <Container>
    <></>
  </Container>
);

ViewComponent.displayName = 'Home-view';

export default ViewComponent;
